/**
 * Tipos das consultorias ao vivo que as telas leem (fora do contrato: a demonstração não os tem).
 * Arquivo leve, sem as fontes reais, para o chunk do Backend, do Hoje e da TV não carregar o modo ao
 * vivo à toa.
 *
 * Três coisas diferentes com o nome "consultoria" (achado 72), cada uma com o próprio nome na tela:
 * - "Contratos de consultoria (R$ 100 mil)": o pipeline do Backend, que ainda não tem registro real;
 * - "Consulta individual (Premium)": o produto Programa América Premium (US$ 397, convertido em real pela PTAX do dia) pago na Kiwify;
 * - "Leads para consultoria (direct)": a fila do direct nas Automações (só a contagem, ao lado do Premium).
 */
import type { BackendReport, Cents } from '@rota/contracts';

/** Contagem e valor (valor dos produtos, sem juros do parcelamento). */
export interface CountCents {
  count: number;
  cents: Cents;
}

/** O que o relatório do backend ao vivo traz a mais (fora do contrato; a demonstração não tem). */
export interface LiveBackendExtras {
  /** Calculado com os dados reais (modo ao vivo). */
  live: true;
  /**
   * O registro dos contratos de consultoria (negociações, propostas, contratos, conversas do WhatsApp)
   * ainda não existe: as etapas B0 em diante, o placar, o quadro e o valor em jogo não são medidos.
   */
  registry: 'off';
  /** Compradores do 20X (pedidos pagos) desde o início, sem o período nem os Filtros. */
  upsellAllTime: number;
  /** Compradores do 20X (pedidos pagos) no período e nos Filtros escolhidos. */
  upsellInPeriod: number;
  /** Consulta individual (Premium) paga: no período escolhido e no mês corrente (São Paulo). */
  premium: { period: CountCents; month: CountCents };
  /** A meta de consultas do mês foi salva pelo dono em Ajustes (sem ela, nada de meta inventada). */
  goalSaved: boolean;
  /**
   * Leads para consultoria (direct) esperando atendimento agora (fila "consultoria" das Automações).
   * null = o servidor não respondeu (a linha some, nunca "0 esperando").
   */
  consultingLeads: number | null;
}

export type LiveBackendReport = BackendReport & LiveBackendExtras;

/** O relatório veio do modo ao vivo? Devolve os campos a mais, ou null (demonstração). */
export function liveBackend(r: BackendReport | null | undefined): LiveBackendExtras | null {
  return r && (r as Partial<LiveBackendExtras>).live === true ? (r as LiveBackendReport) : null;
}

/** Erro do comando do backend no modo ao vivo (nada vai para a memória da simulação). */
export const BACKEND_REGISTRY_OFF = 'Registro de consultorias ainda não disponível';

/** Fila de Conversas (Automações) dos leads para consultoria: no painel das conversas ela é a do Tiago. */
export const CONSULTING_LEADS_HREF = '~/automacoes/conversas?fila=expert';
